import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import styled from "styled-components";
import colors from "../../theme/color/ColorTheme";
import fontSize from "../../theme/fonts/FontTheme";

const Wrapper = styled.div`
  position: fixed;
  bottom: 40px;
  right: 40px;
  color: ${colors.black};
  z-index: 1000;
  pointer-events: ${(props) => (props.show ? "auto" : "none")};
`;
const Container = styled.div`
  border: 1px solid ${colors.border};
  background-color: ${colors.backgroundPrimary};
  opacity: ${(props) => (props.show ? 1 : 0)};
  display: flex;
  transform: translateY(${(props) => (props.show ? "0" : "40px")});
  transition: all 0.3s ease-in-out;
  @media (max-width: 600px) {
    max-width: 300px;
  }
`;
const AnimationWrapper = styled.div`
  width: 120px;
  height: 120px;
  flex-shrink: 0;
`;

const Message = styled.div`
  display: flex;
  padding: 20px 0px;
  padding-right: 20px;
  width: 280px;
  flex-direction: column;
  gap: 10px;
  p {
    font-size: ${fontSize.m};
    margin: 0;
  }

  p:nth-of-type(2) {
    font-size: ${fontSize.s};
  }
`;

function OrderPlacedPopup({ show, title, message }) {
  return (
    <Wrapper show={show}>
      <Container show={show}>
        <AnimationWrapper>
          <DotLottieReact
            src="https://lottie.host/d265f9f2-65aa-4b94-88d9-473917569bba/CJoddm8cpv.lottie"
            loop
            autoplay
          />
        </AnimationWrapper>
        <Message>
          <p>{title}</p>
          <p>{message}</p>
        </Message>
      </Container>
    </Wrapper>
  );
}

export default OrderPlacedPopup;
